import { injectable } from "inversify";
import QARepository from "../../repositories/qa.repository";
import QAAgentEntity from "../../entities/qa_agent.entity";
import { Either, isLeft } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/error.entity";

interface _Props {
    qaRepository: QARepository;
}
@injectable()
export default class GetAgentByIdUseCase {
    private qaRepository: QARepository;
    constructor(props: _Props) {
        this.qaRepository = props.qaRepository;
    }
    public call = async (id: string) : Promise<Either<ErrorEntity, QAAgentEntity>> => {
        return this.qaRepository.getAgentById(id);
    }
}

export const GetAgentByIdUseCaseName = "GetAgentByIdUseCase";